
export const API_PARKING = 'http://parkingappbe.eastasia.cloudapp.azure.com';



